/**
 * Section header used inside long modal bodies (Privacy / Terms).
 * Renders the title in a heavier weight, then the body children below it.
 */
export default function Section({ title, children }) {
  return (
    <>
      <div style={{ fontSize: 13, fontWeight: 500, color: "#333", marginBottom: 6 }}>{title}</div>
      {children}
    </>
  );
}
